import { requests } from "../../../../api/agent"

export default {
	create               : (params) => requests.post('/tariffRate/create', params),
	update               : (params) => requests.post('/tariffRate/update', params),
	delete               : (params) => requests.getWithParams('/tariffRate/delete', params),
	restore              : (params) => requests.getWithParams('/tariffRate/restore', params),
    getPagedAll          : (params) => requests.getWithParams('/tariffRate/getPagedAll', params),
	getPagedAudit        : (params) => requests.getWithParams('/tariffRate/getPagedAudit', params),
	getList              : (params) => requests.getWithParams('/tariffRate/getList', params),
	getListByYear        : (params) => requests.get('/tariffRate/getListByYear/' + params),
}
